import { IQueryTypeFragments } from '~api/QueryFragments';

export enum QueryType {
    userInfo = 'User',
    loyaltyLevelCurrent = 'LoyaltyLevelCurrent',
    loyaltyLevelNext = 'LoyaltyLevelNext'
}

export const userInfoFragment = `
    on ${QueryType.userInfo} {
        acceptedLoyaltyTerms
        birthdayDay
        birthdayMonth
        birthdayYear
        emailAddress
        firstName
        lastName
        fullName
        lastSource
        nextAnniversaryDate
        loyaltyActiveFlag
        onlineUserId
    }
`;

export const defaultFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.userInfo]: userInfoFragment
    };
};
